import { AppMessages } from '../messages/message';

export const appMessages: AppMessages = {
  unknownError: `An unknown error occurred. Please try again. If the problem persists, please contact support.`,
  signInSuccess: 'Sign in successful!',
  invalidCredentials: `Invalid login credentials. Please try again or reset your password.`,
  unknownSignInError: `An error occurred while signing in. Please try again. If the problem persists, please contact support.`,

  /*
   * Sign In
   */
  confirmAttrTitle: `Verify your :attrType`,
  confirmAttrSubtitle: `We will send you a link to verify your :attrType.`,
  confirmAttrBody: `Please confirm the :attrType is correct before requesting to send the verification link.`,
  confirmAttrQuestion: 'Incorrect :attrType?',

  confirmResetPasswordSuccess: `Password reset successful, now you can sign in.`,
  confirmResetPasswordError: `An error occurred while resetting the password. Please try again. If the problem persists, please contact support.`,

  confirmSignInWithSmsCode: `A six-digit authentication code send to <b>:destination</b>.`,
  confirmSignInWithTotpCode: `Please enter the six-digit code from your authenticator app.`,

  /*
   * Forgot password page
   */
  forgotPasswordPageTitle: `Forgot your password?`,
  forgotPasswordPageSubtitle: `Enter your email below and we will send a message to reset your password.`,
  resetPasswordPageTitle: `Reset your password`,
  resetPasswordPageSubtitle: `Enter the code sent to your email and set a new password.`,

  disclaimer: `By continuing, you agree to receive the latest offers from FantaZ on your phone. No purchase is necessary. Message frequency may vary. Standard message and data rates may apply. To unsubscribe, reply STOP or go to Notifications Preferences in the Preferences tab of your profile. For more information, reply HELP. Please refer to FantaZ’s <a class="link" href="/policies/terms">Terms and Conditions</a> and <a class="link" href="/policies/privacy">Privacy Policy</a> for further details.`,
};
